module.exports = __webpack_public_path__ + "img/2-quad.3dcc55cb.png";